import styles from '../styles/color/id.module.scss';
import React, { useEffect, useState } from 'react'
import { colorItem } from '../../constants/api'
import { http } from '../../utils/api'
import Layout from '../../components/MyLayout'
import { NextPage, NextPageContext } from 'next';
import { Item } from '../../@types/color';
import ColorItem from '../../components/Color';
import { Col, message, Row, Tooltip } from 'antd';
import parse from "parse-color";
import CopyToClipboard from 'react-copy-to-clipboard';
import { title } from '../../constants/heads';
import { useSelector } from 'react-redux';
import { State } from '../../@types/reducer';
type Props = {
  item: Item
  list: Item[]
  imgUrl: string
}

const ColorId: NextPage<Props> = (props) => {
  // const baseUrl = useSelector((state: State) => state.baseUrl)
  const { isXs, isSm, isMd, isXxl } = useSelector((state: State) => state.responsive)
  const { item, imgUrl, list } = props
  const head = item.type == 1 ? {
    title: `${item.tags.join('、')}配色板-${title}`,
    description: `此配色板由${item.colors.length}种色彩组成，中文名称:${item.tags.join('、')}，传统色彩名称:${item.tags_td.join('、')}，英文名称:${item.tags_en.join('、')}，二进制色值：${item.colors.join('、')}。可直接使用在插画、UI、网页、电商、包装等等设计上。`,
    keywords: `${item.tags.join(',')}`
  } : {
    title: `${item.tags.join('、')}渐变-${title}`,
    description: `此渐变背景由${item.colors.length}种色彩组成，中文名称:${item.tags.join('、')}，传统色彩名称:${item.tags_td.join('、')}，英文名称:${item.tags_en.join('、')}，二进制色值：${item.colors.join('、')}。可直接使用在插画、UI、网页、电商、包装等等设计上。`,
    keywords: `${item.tags.join(',')}`
  }

  const bg = (color: string) => (
    <CopyToClipboard text={color}
      onCopy={(e) => { message.success('复制成功') }}>
      <Tooltip placement="top" title={`复制 ${color}`}>
        <div className="color-bg" style={{ backgroundColor: color }}></div>
      </Tooltip>
    </CopyToClipboard>
  )
  return (
    <Layout head={head} className={styles.details}>
      <ColorItem max imgUrl={imgUrl} item={item} />
      {item.type != 3 &&
        isXxl || isMd ? <div className="content">
        <Row className="items" gutter={[16, 16]}>
          <Col span={2}>颜色</Col>
          <Col span={3}>HEX</Col>
          <Col span={3}>RGB</Col>
          <Col span={3}>HSL</Col>
          <Col span={3}>CMYKA</Col>
          <Col span={3}>中文名称</Col>
          <Col span={3}>中文传统名称</Col>
          <Col span={4}>英文名称</Col>
        </Row>
        {item.colors.map((v, k) => (
          <Row key={k} className="items" gutter={[16, 16]}>
            <Col span={2}>
              {bg(v)}
            </Col>
            <Col span={3}>{v}</Col>
            <Col span={3}>{parse(v).rgb.join(',')}</Col>
            <Col span={3}>{parse(v).hsl.join(',')}</Col>
            <Col span={3}>{parse(v).cmyka.join(',')}</Col>
            <Col span={3}>{bg(item.near_colors[k])}{item.tags[k]}</Col>
            <Col span={3}>{bg(item.near_colors_td[k])}{item.tags_td[k]}</Col>
            <Col span={4}>{bg(item.near_colors_en[k])}{item.tags_en[k]}</Col>
          </Row>
        ))}</div> : <>
        {item.colors.map((v, k) => (
          <div className="content">
          <Row key={k} className="items" gutter={[16, 8]}>
            <Col span={8}>颜色</Col>
            <Col span={16}>
              {bg(v)}
            </Col>
            <Col span={8}>HEX</Col><Col span={16}>{v}</Col>
            <Col span={8}>RGB</Col><Col span={16}>{parse(v).rgb.join(',')}</Col>
            <Col span={8}>HSL</Col><Col span={16}>{parse(v).hsl.join(',')}</Col>
            <Col span={8}>CMYKA</Col><Col span={16}>{parse(v).cmyka.join(',')}</Col>
            <Col span={8}>中文名称</Col><Col span={16}>{bg(item.near_colors[k])}{item.tags[k]}</Col>
            <Col span={8}>中文传统名称</Col><Col span={16}>{bg(item.near_colors_td[k])}{item.tags_td[k]}</Col>
            <Col span={8}>英文名称</Col><Col span={16}>{bg(item.near_colors_en[k])}{item.tags_en[k]}</Col>
          </Row>
          </div>
        ))}</>
      }
      <h3>相关配色</h3>
      <Row gutter={[20, 20]} className={item.type == 1 ? styles.itemsPlate : styles.itemsGradual}>
        {list.map((item, k) => (
          <Col key={k} xs={24} sm={24} md={12} lg={8} xl={6}>
            <ColorItem imgUrl={imgUrl} item={item} />
          </Col>
        ))}
      </Row>
    </Layout>
  )
}

ColorId.getInitialProps = async ({ query, req }: NextPageContext) => {
  const res: any = await http(colorItem, { id: query.id }, req)
  return { item: res.data, list: res.list, imgUrl: res.imgUrl }
}

export default ColorId